import { render, staticRenderFns } from "./rules.vue?vue&type=template&id=6e7a0498&"
import script from "./rules.vue?vue&type=script&lang=ts&"
export * from "./rules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports